export const personalMenu = [
  {
    // 个人中心
    title: 'personal',
    icon: 'icon-gerenzhongxin',
    children: [
      {
        title: 'password',
        path: '/personal/password',
        icon: 'icon-a-baomizidianmian',
        isLeaf: true,
      },
      {
        title: 'auth',
        path: '/personal/auth',
        icon: 'icon-quanxianguanli',
        isLeaf: true,
      },
      {
        title: 'personalBenefitsCenter',
        path: '/personal/benefits-center',
        icon: 'icon-youhuijuan',
        isLeaf: true,
      },
    ],
  },
];
